
import { authorizeMe, axiosInstance} from './commonHeadApiLogic.js';

// Ensure authorization header is set before making authenticated requests
const withAuthorization = async (apiFunction, ...args) => {
  try {
    await authorizeMe(); // Ensure the Authorization header is set
    return await apiFunction(...args);
  } catch (error) {
    // Handle errors as necessary
    console.error("Error in API request:", error);
    throw error;
  }
};

export async function getPromocodesAPI(page = 1, LIMIT) {
  return withAuthorization(async () => {
    return axiosInstance.get(`/api/admins/coupon?page=${page}&limit=${LIMIT}`);
  });
}

export const AddPromocodeAPI = (payload) => {
  return withAuthorization(async () => {
    return axiosInstance.post(`/api/admins/coupon`, payload);
  });
};

export const UpdatePromocodeAPI = (id, payload) => {
  return withAuthorization(async () => {
    return axiosInstance.put(`/api/admins/coupon/${id}`, payload);
  });
};

export const DeletePromocodeAPI = (id) => {
  return withAuthorization(async () => {
    return axiosInstance.delete(`/api/admins/coupon/${id}`);
  });
};
